import {
  Box,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import MapAddUpdateFieldComponent from "../map/MapAddUpdateField.component";
import { ErrorMessage, Field } from "formik";
import { useTranslation } from "react-i18next";
import palette_custom from "../../palette";

const GeneralInfoFormComponent = ({
  formikProps,
  weatherStation,
  handleChange,
  weatherStations,
}) => {
  const { t } = useTranslation();
  const { touched, errors } = formikProps;
  return (
    <Box width="100%" height="auto" display="flex">
      <Grid container spacing={3}>
        <Grid item xs={12} sm={9}>
          <MapAddUpdateFieldComponent formikProps={formikProps} />
          <ErrorMessage name="polygons">
            {(msg) => (
              <div style={{ color: palette_custom.error, marginTop: 4 }}>
                {msg}
              </div>
            )}
          </ErrorMessage>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Stack spacing={2} marginTop={5}>
            <Field
              as={TextField}
              label={`${t("field_form.field_name")}*`}
              name="label"
              variant="outlined"
              error={formikProps.errors.label}
              helperText={formikProps.errors.label}
            />
            <Field type="hidden" name="id_thing" />
            <FormControl fullWidth>
              <InputLabel id={"weather-station-select"}>
                {t("field_form.field_weather_station")}
              </InputLabel>
              <Select
                label={t("field_form.field_weather_station")}
                id="weather_station"
                name="weather_station"
                value={weatherStation ?? ""}
                onChange={handleChange}
              >
                <MenuItem value="">
                  <em>{t("none")}</em>
                </MenuItem>
                {weatherStations &&
                  weatherStations?.data?.map((station) => (
                    <MenuItem key={station.id} value={station.id}>
                      {station.attributes.label}
                    </MenuItem>
                  ))}
              </Select>
              <ErrorMessage name="weather_station" component="div" />
            </FormControl>
            <FormControl
              fullWidth
              error={
                touched?.soil_type?.climate_zone &&
                Boolean(errors?.soil_type?.climate_zone)
              }
            >
              <InputLabel id="climate-zone-select">
                {`${t("soilType.pilot_area")}*`}
              </InputLabel>
              <Field name="soil_type.pilot_area">
                {({ field, meta }) => (
                  <Select
                    {...field}
                    label={t("soilType.pilot_area")}
                    id="soil_type.pilot_area"
                    labelId="climate-zone-select"
                    fullWidth
                    error={meta.touched && Boolean(meta.error)}
                  >
                    <MenuItem value="">
                      <em>{t("none")}</em>
                    </MenuItem>
                    <MenuItem value="sardinia">
                      {t("climate_zone_options.italy")}
                    </MenuItem>
                    <MenuItem value="tunisia">
                      {t("climate_zone_options.tunisia")}
                    </MenuItem>
                    <MenuItem value="jordan">
                      {t("climate_zone_options.jordan")}
                    </MenuItem>
                    <MenuItem value="lebanon">
                      {t("climate_zone_options.lebanon")}
                    </MenuItem>
                  </Select>
                )}
              </Field>
              {touched?.soil_type?.climate_zone &&
                errors?.soil_type?.climate_zone && (
                  <FormHelperText error>
                    {errors?.soil_type?.climate_zone}
                  </FormHelperText>
                )}
            </FormControl>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default GeneralInfoFormComponent;
